import React from 'react';
import DocPage from './DocPage';

const sections = [
  {
    id: 'agreement',
    title: 'Your agreement with us',
    body: (
      <p>
        By booking a service or using our facilities, you agree to these terms. They set out what
        you can expect from us, and what we expect from you.
      </p>
    ),
  },
  {
    id: 'bookings',
    title: 'Bookings',
    body: (
      <p>
        Bookings are confirmed once payment is received and capacity is available. We will always
        confirm in writing — by email or message.
      </p>
    ),
  },
  {
    id: 'pet-safety',
    title: 'Pet safety',
    body: (
      <p>
        Pets must be up to date on core vaccinations. We reserve the right to refuse service if a
        pet poses a risk to themselves, other pets or our team.
      </p>
    ),
  },
  {
    id: 'liability',
    title: 'Liability',
    body: (
      <p>
        We follow strict safety and hygiene protocols, but pet care carries inherent risk. By using
        our services you acknowledge and accept this.
      </p>
    ),
  },
];

const TermsOfService = () => (
  <DocPage title="Terms of Service" lastUpdated="May 2026" sections={sections} />
);

export default TermsOfService;
